<script setup lang="ts">
withDefaults(defineProps<{
  color?: string
  rounded?: boolean | string
  elevation?: number
  border?: boolean
}>(), {})
</script>

<template>
  <div
    class="m-sheet"
    :class="{
      'm-sheet--rounded': rounded,
      'm-sheet--border': border,
      [`elevation-${elevation}`]: elevation !== undefined,
    }"
  >
    <slot />
  </div>
</template>

<style scoped>
.m-sheet {
  background: var(--m-surface);
  padding: var(--m-space-4);
}
.m-sheet--rounded { border-radius: var(--m-radius); }
.m-sheet--border { border: 1px solid var(--m-border); }
</style>
